import React from 'react';
import { Alert } from '@mui/material';
import { useEntity } from '@backstage/plugin-catalog-react';
import { ArgusAppComponentEntity } from '@eng-portal/czi-extensions-common';
import { AppCard } from '@eng-portal/plugin-argus';

export function ArgusAppDetailsCard(): JSX.Element {
  const { entity } = useEntity<ArgusAppComponentEntity>();

  const { app } = entity.spec;
  if (!app) {
    return <Alert severity="error">Argus app not found</Alert>;
  }

  return <AppCard app={app} />
}
